// frontend/src/components/purchase-orders/usePurchaseOrderFiles.js
//
// The files one purchase order produces — its PDF and its items as CSV or
// Excel.
//
// Fetch, busy flag and toasts come from useBlobDownload (shared with
// <RecommendationRowActions>); why the busy flag exists is that hook's to
// state. Which files a PO offers is ./poActions.js's call.
//
//   const files = usePurchaseOrderFiles(po);
//   files.download(PO_ACTION.DOWNLOAD_PDF | DOWNLOAD_CSV | DOWNLOAD_XLSX)
//   files.downloading          // a file is being generated

import { useCallback } from 'react';
import { useBlobDownload } from '../../hooks/useBlobDownload';
import { poDownloadFilename } from '../../utils/download';
import { PO_ACTION } from './poActions';

const ENDPOINT = '/api/po-calculations/purchase-orders/';

export function usePurchaseOrderFiles(po) {
  const { busy: downloading, download: fetchFile } = useBlobDownload();
  const poId = po.purchase_order_header_id;
  const poNumber = po.po_number;

  const download = useCallback((action) => {
    if (action === PO_ACTION.DOWNLOAD_PDF) {
      return fetchFile({
        url: `${ENDPOINT}${poId}/download_pdf/`,
        filename: poDownloadFilename(poNumber, 'pdf'),
        failureKey: 'purchaseOrders.messages.pdfFailed',
        successKey: 'purchaseOrders.messages.pdfSuccess',
        values: { poNumber },
      });
    }
    const format = action === PO_ACTION.DOWNLOAD_CSV ? 'csv' : 'xlsx';
    return fetchFile({
      url: `${ENDPOINT}${poId}/export/?file_format=${format}`,
      filename: poDownloadFilename(poNumber, format),
      failureKey: 'purchaseOrders.messages.itemsFailed',
      successKey: 'purchaseOrders.messages.itemsSuccess',
      values: { poNumber },
    });
  }, [fetchFile, poId, poNumber]);

  return { download, downloading };
}
